<h1 mat-dialog-title>E-Rechnung</h1>
<mat-dialog-content>
    <app-e-invoice-view style="max-height: unset;" *ngIf="eInvoiceEntity$ | async as eInvoice; else loading" mat-dialog-content [EInvoice]="eInvoice"></app-e-invoice-view>
</mat-dialog-content>
<mat-dialog-actions>
    <button app-button Color="cancel" Inverted mat-dialog-close="">Schließen</button>
</mat-dialog-actions>
<ng-template #loading><app-loading></app-loading></ng-template>
